import { render, staticRenderFns } from "./VendorUsersTable.vue?vue&type=template&id=913a1330&scoped=true&"
import script from "./VendorUsersTable.vue?vue&type=script&lang=js&"
export * from "./VendorUsersTable.vue?vue&type=script&lang=js&"
import style0 from "./VendorUsersTable.vue?vue&type=style&index=0&id=913a1330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913a1330",
  null
  
)

export default component.exports